<!-- 单独审批列表 -->
<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.merchantName')">
            <el-select
                v-model="form.appId"
                filterable
                :placeholder="$t('message.chooseOne')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="merchant in merchantList"
                  :label="merchant.value + '-' + merchant.name"
                  :key="merchant.value"
                  :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.withdrawalStatus')">
            <el-select v-model="form.status" :placeholder="$t('text.status')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('withdrawalStatus.00')" value="00"></el-option>
              <el-option :label="$t('withdrawalStatus.01')" value="01"></el-option>
              <el-option :label="$t('withdrawalStatus.02')" value="02"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.rechargeType')">
            <el-select v-model="form.selectionType">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('text.returnU')" value="01"></el-option>
              <el-option :label="$t('text.debit')" value="03"></el-option>
              <el-option :label="$t('text.payinCredit')" value="04"></el-option>
              <el-option :label="$t('text.pending')" value="99"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.orderNumber')">
            <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.date')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="tableColumn">
          <el-table-column
              width="180"
              prop="orderId"
              :label="$t('text.orderNumber')"
              fixed
              align="center"
          ></el-table-column>


          <el-table-column
              prop="status"
              :label="$t('text.withdrawalStatus')"
              width="100px"
              :formatter="$formatter.formatApprovalStatus"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="
                row.status === '00'
                  ? 'warning'
                  : row.status === '01'
                  ? 'success'
                  : 'danger'
              "
              >{{
                  $formatter.formatApprovalStatus(null, null, row.status, null)
                }}
              </el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
              width="170"
              prop="appId"
              :label="$t('text.appId')"
              align="center"
          ></el-table-column>
          <el-table-column
              width="160"
              prop="merchantName"
              :label="$t('text.merchantName')"
              align="center"
          ></el-table-column>


          <el-table-column
              prop="selectionType"
              :label="$t('text.rechargeType')"
              width="100px"
              :formatter="$formatter.formatRechargeWithdrawRechargeType"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="
                row.selectionType == '00' || row.selectionType == '01'
                  ? 'into'
                  : row.selectionType == '02' || row.selectionType == '03'
                  ? 'warning'
                  : 'danger'
              "
              >{{
                  $formatter.formatRechargeWithdrawRechargeType(null, null, row.selectionType, null)
                }}
              </el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
              prop="amount"
              :formatter="$formatter.FenToYuanToThousandth"
              width="130px"
              :label="$t('text.withdrawalAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="200"
              prop="collectAccount"
              :label="$t('text.collectionAddress')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="withdrawExchangeRate"
              :label="$t('text.withdrawExchangeRate')"
              width="80"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="withdrawUSDAmount"
              :label="$t('text.withdrawUSDTAmount')"
              width="100"
              :formatter="$formatter.FenToYuanToThousandth"
              align="center"
          ></el-table-column>

          <el-table-column
              width="160"
              prop="dealTimeFormat"
              :label="$t('text.processingTime')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="160"
              prop="approveRemark"
              :label="$t('text.approvalRemark')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.approveRemark">
                <el-popover
                    v-if="row.approveRemark && row.approveRemark.length > 10"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.approveRemark"
                >
                  <div slot="reference" class="remark">
                    {{ row.approveRemark }}
                  </div>
                </el-popover>
                <div v-else>{{ row.approveRemark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              width="160"
              prop="remark"
              :label="$t('text.applicationNote')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.remark">
                <el-popover
                    v-if="row.remark.length > 10"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.remark"
                >
                  <div slot="reference" class="remark">{{ row.remark }}</div>
                </el-popover>
                <div v-else>{{ row.remark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              width="160"
              prop="createTimeFormat"
              :label="$t('text.creationTime')"
              align="center"
          ></el-table-column>

          <el-table-column
              fixed="right"
              :label="$t('text.actions')"
              width="160"
              align="center"
              v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isBusinessCustomerServiceManage()"
          >
            <template slot-scope="{ row }">
              <el-button
                  type="primary"
                  size="mini"
                  plain
                  :disabled="row.status!=='00'"
                  @click="handleApprove('01', row)"
              >{{ $t('text.approve') }}
              </el-button
              >
              <el-button
                  type="danger"
                  size="mini"
                  plain
                  :disabled="row.status!=='00'"
                  @click="handleApprove('02', row)"
              >{{ $t('text.reject') }}
              </el-button
              >
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
    <ApproveRechargeWithdraw
        :is-show-adopt-dialog.sync="isShowAdoptDialog"
        :id="id"
        type="withdraw"
        :rowData="rowData"
    ></ApproveRechargeWithdraw>
    <RejectRechargeWithdraw :is-show-refuse-dialog.sync="isShowRefuseDialog" :id="id "></RejectRechargeWithdraw>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import ApproveRechargeWithdraw from './components/ApproveRechargeWithdraw.vue'
import RejectRechargeWithdraw from './components/RejectRechargeWithdraw.vue'
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  name: 'Systems',
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
    ApproveRechargeWithdraw: ApproveRechargeWithdraw,
    RejectRechargeWithdraw: RejectRechargeWithdraw,
  },

  data() {
    return {
      url: '/depositWithdraw/selectList?type=01',
      action: '',
      timeDate: [],
      form: {
        appId: '',
        startDate: '',
        endDate: '',
        tradeOrderId: '',
        selectionType: '',
      },
      showDialog: false,
      formData: null,
      totalAmount: '',
      totalFee: '',
      totalActualAmount: '',
      merchantList: [],
      isShowAdoptDialog: false,
      isShowRefuseDialog: false,
      id: '',
      rowData: '',
    }
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate)
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
    },
    add() {
      this.action = 'addWithdraw'
      this.formData = null
      this.showDialog = true
    },
    handleApprove(type, row) {
      this.id = row.orderId
      this.rowData = row
      if (type === '01') {
        this.isShowAdoptDialog = true
      } else {
        this.isShowRefuseDialog = true
      }
    },
    confirm(row) {
      this.$confirm(this.$t('message.confirmDoingWithdrawal'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('withdrawInfo.dialog.button.cancel.label'),
        type: 'warning',
      })
          .then(() => {
            this.axios
                .post('/withdraw/confirm', {orderId: row.orderId, selectionType: row.selectionType})
                .then(res => {
                  if (res.code === 200) {
                    this.$bus.$emit('refresh') //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: 'success',
                    })
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                    })
                  }
                })
          })
          .catch(() => {
          })
    },
    setSuccess(row) {
      this.$confirm(this.$t('message.confirmSettingSuccess'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('withdrawInfo.dialog.button.cancel.label'),
        type: 'warning',
      })
          .then(() => {
            this.axios
                .post('/withdraw/setSuccess', {orderId: row.orderId})
                .then(res => {
                  if (res.code === 200) {
                    this.$bus.$emit('refresh') //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: 'success',
                    })
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                    })
                  }
                })
          })
          .catch(() => {
          })
    },
    exportDetail() {
      this.axios
          .get('/withdraw/exportDetail', {params: this.form})
          .then(res => {
            if (res.code === 200) {
              window.location.href =
                  '/common/downloadFile?fileId=' + res.data.fileId
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              })
            }
          })
    },
    reject(row) {
      this.$prompt(this.$t('message.inputRejectionReason'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('withdrawInfo.dialog.button.cancel.label'),
      })
          .then(({value}) => {
            this.axios
                .get('/withdraw/reject', {
                  params: {
                    orderId: row.orderId,
                    rejectMessage: value,
                  },
                })
                .then(res => {
                  this.$bus.$emit('refresh') //通知刷新
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                  })
                })
          })
          .catch(() => {
          })
    },
  },
  created() {
    this.$axios
        .get('/merchant/selectListForOption', {params: {}})
        .then(res => {
          this.merchantList = res.data
          if (this.merchantList.length === 1) {
            this.form.appId = this.merchantList[0].value
            this.$bus.$emit('refresh')
          }
        })
  },
}
</script>

<style scoped>
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active,
.el-button--danger.is-disabled,
.el-button--danger.is-disabled:hover,
.el-button--danger.is-disabled:focus,
.el-button--danger.is-disabled:active {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>